import { render, staticRenderFns } from "./Howdoesitwork.vue?vue&type=template&id=567047de&scoped=true&"
import script from "./Howdoesitwork.vue?vue&type=script&lang=js&"
export * from "./Howdoesitwork.vue?vue&type=script&lang=js&"
import style0 from "./Howdoesitwork.vue?vue&type=style&index=0&id=567047de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567047de",
  null
  
)

export default component.exports